module.exports = __webpack_public_path__ + "static/media/tptpx_m.6caa865d.png";